import React from 'react';
import RecordPrint from '../../components/Record/RecordPhotoPrint';

const RecordPrintPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>사진기록증</div>
            <RecordPrint/>
        </div>
    );
};

export default RecordPrintPage;